import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 scroll-mt-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">深度阅读</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选专题</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">编辑团队精心策划的漫画深度专题内容</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
          {carouselItems.map((item) => (
            <div key={item.id} className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer lg:col-span-1">
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).classList.add('hidden');
                  }}
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 group-hover:text-accent-600 transition-colors mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}